<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Veicolo: <strong>{{ selectedContract ? selectedContract.alias : '' }}</strong> Start: <strong>{{ startAt | formatDate }}</strong> - Stop: <strong>{{ stopAt | formatDate }}</strong>
      </div>
      <div id="map_canvas" style="height: 600px"></div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'route-details',
  data () {
    return {
      map: null,
      center: true,
      loading: false,
      polyline: null,
      markerStart: null,
      markerStop: null,
      routeDetails: [],
      center: {lat: 45.6, lng: 8.7},
    }
  },

  mounted() {
    let latlng = new google.maps.LatLng(45.6, 8.7)
    let mapOptions = {
      zoom: 10,
      center: latlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    }
    this.map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);
    this.loadRouteDetails();
  },
  methods: {
    loadRouteDetails() {
      this.loading = true;
      this.$store.dispatch('routeDetails', { routeId: this.$route.params.id })
        .then((routeDetails) => {
          this.routeDetails = routeDetails;
          this.drawPath();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    drawPath() {
      let pinOn = {
        url: 'img/map/start.png',
        size: new google.maps.Size(28, 34),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(14, 34)
      };

      let pinOff = {
        url: 'img/map/stop.png',
        size: new google.maps.Size(28, 34),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(14, 34)
      };

      if (this.routeDetails.length <= 2) return;
      if (this.polyline) this.polyline.setMap(null);
      let path = this.routeDetails.map(p => ({ lat: p.latitude, lng: p.longitude}));
      this.polyline = new google.maps.Polyline({
        path: path,
        strokeColor: "#0000ff",
        strokeOpacity: 0.7,
        strokeWeight: 3
      });
      this.polyline.setMap(this.map);
      let bounds = new google.maps.LatLngBounds();
      path.forEach(function(item, index) {
        bounds.extend(item);
      });
      this.map.fitBounds(bounds);

      this.markerStart = new MarkerWithLabel({
        position: path[0],
        map: this.map,
        icon: pinOn,
        labelContent: 'START',
        labelAnchor: new google.maps.Point(30, -3),
        labelClass: "marker-labels-on",
      });

      this.markerStop = new MarkerWithLabel({
        position: path[path.length - 1],
        map: this.map,
        icon: pinOff,
        labelContent: 'STOP',
        labelAnchor: new google.maps.Point(30, -3),
        labelClass: "marker-labels-off",
      });
    }
  },
  computed: {
    startAt() {
      if (this.routeDetails.length === 0) return '';
      return this.routeDetails[0].clockAt;
    },
    stopAt() {
      if (this.routeDetails.length === 0) return '';
      return this.routeDetails[this.routeDetails.length - 1].clockAt;
    },
    ...mapGetters([
        'routes',
        'selectedContract',
      ]),
  },
}
</script>

<style>
.marker-labels-off {
    color: red;
    background-color: white;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    width: 60px;
    border: 1px solid red;
    white-space: nowrap;
  }

  .marker-labels-on {
    color: green;
    background-color: white;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    width: 60px;
    border: 1px solid green;
    white-space: nowrap;
  }
</style>
